export const breadcrumbConfig = {
	industrial: {
		nl: 'Industrieel',
		fr: 'Industriel',
	},
	household: {
		nl: 'Huishoudelijk',
		fr: 'Ménage',
	},
	products: {
		nl: 'Categorieën',
		fr: 'Catégories',
	},
	rent: {
		nl: 'Verhuur',
		fr: 'Verhuur',
	},
	compare: {
		nl: 'Vergelijk',
		fr: 'Comparer',
	},
};



// WEBPACK FOOTER //
// ./src/config/breadcrumb.config.js